export default __webpack_public_path__ + "static/initial-f5fd4d03ca6dbaf19de67fe8e968850a.png";